/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import { Modal } from 'antd-mobile'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
// img
import InitialPopupContentsImg from '@assets/images/bg/adv-initial-popup-contents-img.png'
// css
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import { AdvNewsWrap } from '../MatchupBanner'

const InitialPopup: React.FC = () => {
  const { globalStore } = useRootStore()
  const { visibleInitialPopup } = globalStore

  const doCloseInitialPopup = () => {
    globalStore.setVisibleInitialPopup(false)
  }

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        visible={visibleInitialPopup}
        animated={isMobile}
        animationType="slide-up"
        title={
          <Fragment>
            <h1 className="title">승부사 소식</h1>
            <Button onClick={doCloseInitialPopup} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className="full-modal message"
        onClose={doCloseInitialPopup}
      >

        <AdvNewsWrap>
          <img src={InitialPopupContentsImg} alt="승부사 소식" className="img"/>
        </AdvNewsWrap>

        <ModalBg onClick={doCloseInitialPopup}/>

      </Modal>
    </Fragment>
  )
}
export default observer(InitialPopup)
